import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
declare const $: any;
declare const toastr: any;
@Injectable()
export class CommonService {
  public loading = new BehaviorSubject<boolean>(false);
  public currentUser = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('CURRENT_USER')));
  public profileStatus = new BehaviorSubject<number>(0);

  public onChangeProfile = new BehaviorSubject<any>('changed');
  constructor() { }
  showToastr(type, content, title, position = 'toast-top-center') {
    toastr.options = {
      "positionClass": position,
      "timeOut": "2000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    toastr[`${type}`](content, title);
  }
  toggleLoading(status) {
    this.loading.next(status);
  }
  storageChanged(data) {
    this.currentUser.next(data);
  }
  profileUpdated(eventType) {
    this.profileStatus.next(eventType);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/common/common.service.ts